import { useState } from 'react';

export type PromptModalMode = 'edit' | 'copy' | 'add';

export function usePromptModalMode(initialMode: PromptModalMode = 'add') {
    const [modalMode, setModalMode] = useState<PromptModalMode>(initialMode);
    return [modalMode, setModalMode] as const;
}
